import React, { useEffect, useState } from "react";
import { DashBoardData } from "../../../models/props";
import userService from "../../../services/userService";
import { MdLoop } from "react-icons/md";

//styles
import "./Dashboard.css";
import Frame from "../Frame/Frame";

export default function DashBoard(props: any): JSX.Element {
  const [data, setData] = useState<DashBoardData>({
    cashierTill: 1000.0,
    depositCount: 1,
    maturedFixedDeposits: 2000.0,
    totalDeposit: 300.0,
    totalWithdrawal: 4000.0,
    withdrawalCount: 300.0,
  });

  const refreshData = async () => {
    var resp = await userService.getDashBoardData();
    if (resp.status) {
      setData({
        cashierTill: resp.data?.cashierTill as number,
        depositCount: resp.data?.depositCount as number,
        maturedFixedDeposits: resp.data?.maturedFixedDeposits as number,
        totalDeposit: resp.data?.totalDeposit as number,
        totalWithdrawal: resp.data?.totalWithdrawal as number,
        withdrawalCount: resp?.data?.withdrawalCount as number,
      });
    }
  };

  useEffect(() => {
    refreshData();
  }, []);

  return (
    <Frame>
      <div className="table-responsive dashboard">
        <table id="tbl_user_dashboard" className="table table-condense">
          <thead>
            <tr>
              <th colSpan={2}>
                <div className="dashboard-header">
                  <h5 className="dashboard-title text-primary">Summary</h5>
                  <button
                    title="Click to refresh the dashboard"
                    className="btn btn-sm refresh-button"
                    onClick={() => refreshData()}
                  >
                    <MdLoop />
                  </button>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Total Withdrawal</td>
              <td style={{ textAlign: "right" }}>
                <span className="badge bg-danger">{data?.totalWithdrawal}</span>
              </td>
            </tr>
            <tr>
              <td>Total Deposit</td>
              <td style={{ textAlign: "right" }}>
                <span className="badge bg-success">{data?.totalDeposit}</span>
              </td>
            </tr>
            <tr>
              <td>Withdrawal Count</td>
              <td style={{ textAlign: "right" }}>
                <span className="badge bg-primary">
                  {data?.withdrawalCount}
                </span>
              </td>
            </tr>
            <tr>
              <td>Deposit Count</td>
              <td style={{ textAlign: "right" }}>
                <span className="badge bg-primary">{data?.depositCount}</span>
              </td>
            </tr>
            <tr>
              <td>Matured Fixed Deposit</td>
              <td style={{ textAlign: "right" }}>
                <span className="badge bg-primary">
                  {data?.maturedFixedDeposits.toLocaleString("en-GB")}
                </span>
              </td>
            </tr>
            <tr>
              <td>Cashier Till</td>
              <td style={{ textAlign: "right" }}>
                <span className="badge bg-primary">
                  {data?.cashierTill.toLocaleString("en-GB")}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Frame>
  );
}

export function SideDashBoardPane(props: any) {
  return (
    <div className="dashboard-pane">
      <div className="dashboard-pane-header">
        <h3>Dash board</h3>
        <span className="close" onClick={(e) => alert("dashboard closed")}>
          &times
        </span>
      </div>
      <DashBoard id={""} className={""} />
      {props.children}
    </div>
  );
}

export function MainWindow(props: any) {
  return <div className="main-window">{props.children}</div>;
}
